<!-- @format -->

<div
  class="expandable expandable__variant__{{ variant }}"
  [class.closed]="_closed"
  [class.expandable__variant__no-icon]="hideIcon"
  data-cy="expandable">
  <div
    class="expandable__header expandable__header__variant__{{ variant }}"
    [class.closed]="_closed"
    [class.expandable__header__slim]="slim">
    <div
      [attr.role]="!titleContainerOutside ? 'heading' : null"
      [attr.aria-level]="!titleContainerOutside ? level : null"
      class="expandable__header__heading"
      [class.expandable__header__heading--title-outside]="titleContainerOutside">
      @if (titleContainerOutside) {
        <div role="heading" [attr.aria-level]="level" class="expandable__title__heading-row">
          <button
            type="button"
            class="expandable__title expandable__title__variant__{{ variant }} expandable__title__size__{{ _size }}"
            [class.openable]="!hideIcon"
            [attr.id]="elementId"
            [class.link-button]="link"
            [class.closed]="_closed"
            [attr.data-cy]="'expandable-toggle'"
            [attr.aria-expanded]="!_closed"
            [attr.aria-label]="title"
            [disabled]="disabled"
            (click)="setClosedStatus(!_closed)">
            @if (!hideIcon) {
              <sis-icon
                class="expandable__title__icon"
                [icon]="naked || link ? 'chevron' : 'chevron-ring-fill'"
                [iconClass]="_closed ? null : 'cw-90'"></sis-icon>
            } @else {
              <span class="expandable__title__no-icon"></span>
            }
          </button>
          @if (title) {
            <span aria-hidden="true" class="expandable__title__text expandable__title__size__{{ _size }}">{{ title }}</span>
          }
        </div>
        <div class="expandable__title__container expandable__title__size__{{ _size }}">
          @if (!link) {
            <ng-container *ngTemplateOutlet="customTitleTemplate"></ng-container>
            @if (!!subTitle && !slim) {
              <span class="expandable__title__sub-title expandable__title__sub-title__size__{{ _size }}">{{ subTitle }}</span>
            }
          }
        </div>
      } @else {
        <button
          type="button"
          class="expandable__title expandable__title__variant__{{ variant }} expandable__title__size__{{ _size }}"
          [class.openable]="!hideIcon"
          [attr.id]="elementId"
          [class.link-button]="link"
          [class.closed]="_closed"
          [attr.data-cy]="'expandable-toggle'"
          [attr.aria-expanded]="!_closed"
          [disabled]="disabled"
          (click)="setClosedStatus(!_closed)">
          @if (!hideIcon) {
            <sis-icon
              class="expandable__title__icon"
              [icon]="naked || link ? 'chevron' : 'chevron-ring-fill'"
              [iconClass]="_closed ? null : 'cw-90'"></sis-icon>
          } @else {
            <span class="expandable__title__no-icon"></span>
          }
          <span class="expandable__title__container">
            @if (title) {
              <span class="expandable__title__text">{{ title }}</span>
            }
            @if (!link) {
              <ng-container *ngTemplateOutlet="customTitleTemplate"></ng-container>
              @if (!!subTitle && !slim) {
                <span class="expandable__title__sub-title expandable__title__sub-title__size__{{ _size }}">{{ subTitle }}</span>
              }
            }
          </span>
        </button>
      }
    </div>
    <div class="expandable__header__buttons">
      <ng-container *ngTemplateOutlet="headerButtonsTemplate"></ng-container>
    </div>
  </div>
  @if (_openedOnce) {
    <div
      class="expandable__content expandable__content__padding__{{ _contentPadding }}"
      [class.expandable__content__dotted]="dotted"
      [class.expandable__content__transparent]="transparent"
      [attr.aria-hidden]="_closed"
      [hidden]="_closed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  }
</div>
